import { Component, Input } from '@angular/core';
import { Subject } from '../../../../shared/models/subject';
import { IParentEntity } from 'app/shared/interfaces/entity';

@Component({
  selector: 'file-list-widget',
  templateUrl: './file-list-widget.component.html',
  styleUrls: ['./file-list-widget.component.scss'],
})
export class FileListWidgetComponent {  
  parent: IParentEntity;  
  
  @Input() showMailMergeTemplateDownloadButton = false;  
  @Input() subject: Subject;
  @Input() id: number;
  @Input() subjectId: string;
  @Input() processTypeId: string;
  @Input() settings: any;
  
  constructor() {        
  }  
}
